import { useState } from 'react';
import '../../../../assets/datePickerCustomStyling.css';
import DatePicker from 'react-datepicker';
import { cleanedDateString, formattedDateRange, generateSuggestions, convertLocalToUTCDate } from '../utils';
import { useGetCurrentUserQuery, useGetForecastsQuery } from 'utils/wemble-api';
import { Moment } from 'moment-timezone';
import { haptic } from 'utils/haptics';


const RangeSelect = ({ selectRange, nextDate, classes }: { selectRange: any, classes: any, nextDate?: Moment }) => {

  const { data: user } = useGetCurrentUserQuery();
  const { data: allForecasts } = useGetForecastsQuery({});
  const userForecasts = allForecasts?.filter(forecast => forecast.user === user?._id);
  const forecasts = userForecasts ? [...userForecasts].sort((a, b) => new Date(a.startDate!).getTime() - new Date(b.startDate!).getTime()) : []

  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [hovered, setHovered] = useState<number | null>(null);
  const [pressed, setPressed] = useState<number | null>(null);

  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    if (start && end) {
      selectRange({ startDate: cleanedDateString(convertLocalToUTCDate(start)), endDate: cleanedDateString(convertLocalToUTCDate(end)) })
    }
  };

  const isDesktop = !('ontouchstart' in window);
  const isActive = (i: number) => pressed === i || hovered === i;

  return (<>
    {generateSuggestions(nextDate, forecasts).map((suggestion, i) => (<div
      key={i}
      className={classes.suggestionItem}
      style={{
        backgroundColor: isActive(i) ? '#E8E8E8' : undefined,
        transform: isActive(i) ? 'scale(1.065)' : undefined,
      }}
      onClick={() => { haptic('medium'); selectRange(suggestion.range); }}
      onTouchStart={() => setPressed(i)}
      onTouchEnd={() => setPressed(null)}
      {...(isDesktop ? {
        onMouseEnter: () => setHovered(i),
        onMouseLeave: () => setHovered(null),
      } : {})}
    >
      <div className={classes.subtitle}>{formattedDateRange(suggestion.range)}</div>
      <div className={classes.title}>{suggestion.title}</div>
    </div>))}

    <DatePicker
      wrapperClassName="datePickerCustomStyling"
      selectsRange
      selected={startDate}
      startDate={startDate}
      endDate={endDate}
      onChange={onChange}
      calendarStartDay={1}
      formatWeekDay={(nameOfDay) => nameOfDay.substr(0, 3)}
      filterDate={(date) => date >= new Date() && !(forecasts.find(forecast => forecast.status == 'away' && new Date(cleanedDateString(date)) >= new Date(forecast.startDate || '') && new Date(cleanedDateString(date)) <= new Date(forecast.endDate || '')))}
      disabledKeyboardNavigation
      monthsShown={('ontouchstart' in window) ? 1 : 2}
      customInput={
        (<div
          className={classes.suggestionItem}
          style={{
            position: 'relative',
            height: 40,
            backgroundColor: isActive(-1) ? '#E8E8E8' : undefined,
            transform: isActive(-1) ? 'scale(1.065)' : undefined,
          }}
          onTouchStart={() => setPressed(-1)}
          onTouchEnd={() => setPressed(null)}
          {...(isDesktop ? {
            onMouseEnter: () => setHovered(-1),
            onMouseLeave: () => setHovered(null),
          } : {})}
        >
          <div className={classes.title}>Custom dates</div>
        </div>
        )
      }
    />


  </>)
}

export default RangeSelect
